import { Table, Skeleton } from "@mantine/core";

export function TableSkeletonRules({ length = 20 }) {
  const rows = Array.from({ length: length }).map((_, index) => (
    <Table.Tr key={index}>
      {Array.from({ length: 6 }).map((_, colIndex) => (
        <Table.Td key={colIndex}>
          <Skeleton height={27} radius="sm" />
        </Table.Td>
      ))}
    </Table.Tr>
  ));

  return <Table.Tbody pos="relative">{rows}</Table.Tbody>;
}
